var intro = require('./intro.js');

module.exports = {
	intro: null,
	init: function() {
		'use strict';

		var _self = this;

		if(!$('[data-step]').length || $(window).width() < 601) {
			return false;
		}

		_self.intro = intro.introJs();
		_self.intro.setOption('showButtons', false)
			.setOption('showBullets', false)
			.setOption('tooltipPosition', 'bottom')
			.setOption('showProgress', false);

		$('.quickbook--horizontal').one('click', '.form__group', function(e) {
			$('.activity-cat-1 select').trigger('chosen:open').addClass('chosen-with-drop');
			e.stopPropagation();
			_self.intro.start();
		});

		if($('[data-onload]').length && $(window).width() > 1024){
			var $ele = $('[data-onload]').eq(0)
			  , sessionItemName = (typeof $ele.attr('data-session-item-name') !== 'undefined') ? $ele.attr('data-session-item-name') : 'seenSidebarTour'
			  , position = (typeof $ele.attr('data-position') !== 'undefined') ? $ele.attr('data-position') : 'left'
			  , cssClass = (typeof $ele.attr('data-tooltip-class') !== 'undefined') ? $ele.attr('data-tooltip-class') : 'introjs-tooltip--right introjs-tooltip--quickbook-sidebar'

			if(!sessionStorage.getItem(sessionItemName)){
				_self.intro.setOption('tooltipPosition', position);
				_self.intro.setOption('scrollToElement', false);
				_self.intro.setOption('tooltipClass', cssClass);
				_self.intro.start();

				setTimeout(function(){
					$(window).on('scroll', function(){
						if(_self.intro !== null){
							sessionStorage.setItem(sessionItemName, true);
							_self.intro.nextStep();
						}
					})
				}, 200);

				setTimeout(function(){
					if(_self.intro !== null){
						sessionStorage.setItem(sessionItemName, true);
						_self.intro.nextStep();
					}
				}, 8000);
			}
		}

		_self.intro.onbeforeexit(function() {
			$('.group--tour-dummy').removeClass('group--tour-dummy');
			_self.intro = null;
		});

		_self.intro.onbeforechange(function(targetElement) {
			var $ele = $(targetElement);

			if(typeof $ele.attr('data-intro') === 'undefined' || !$ele.attr('data-intro').length) {
				$('.introjs-tooltipReferenceLayer').addClass('force-hidden-tooltip');
			} else {
				$('.introjs-tooltipReferenceLayer').removeClass('force-hidden-tooltip');
			}
		});

		_self.intro.onchange(function(targetElement) {
			var $ele = $(targetElement);

			if(!$ele.find('.datepicker-wrapper').length) {
				$ele.find('.group__dummy').click();
				$ele.find('.group__trigger').addClass('active');
			}
		});

		_self.intro.onafterchange(function(targetElement) {
			var $ele = $(targetElement);

			if($ele.find('.datepicker-wrapper').length) {
				$('.introjs-tooltipReferenceLayer').addClass('introjs--hidden');
			}
		});

		$('.results-header select').on('chosen:showing_dropdown', function() {
			$('.introjs-tooltipReferenceLayer').addClass('introjs--hidden');
		}).on('chosen:hiding_dropdown', function() {
			$('.introjs-tooltipReferenceLayer').removeClass('introjs--hidden');
		});
	},

	toggleIntroOverlay: function(nextStep) {
		'use strict';

		var _self = this;

		if(typeof nextStep === 'undefined') {
			nextStep = false;
		}

		$('.introjs-tooltipReferenceLayer').toggleClass('introjs--hidden');

		if(nextStep) {
			if(window.snowdome.tour.intro !== null) {
				_self.intro.nextStep();
				$('.group--tour-dummy').removeClass('group--tour-dummy');
			}
		}
	}
};